// JsFromRoutes CacheKey 99320d9fcca4748f7578ea8029cab911
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  places: /* #__PURE__ */ definePathHelper('get', '/consumer/gift_recommendations/places'),
  pin: /* #__PURE__ */ definePathHelper('post', '/consumer/gift_recommendations/pin'),
  unpin: /* #__PURE__ */ definePathHelper('delete', '/consumer/gift_recommendations/pin'),
  hide: /* #__PURE__ */ definePathHelper('post', '/consumer/gift_recommendations/hide'),
  unhide: /* #__PURE__ */ definePathHelper('delete', '/consumer/gift_recommendations/hide'),
  refine: /* #__PURE__ */ definePathHelper('post', '/consumer/gift_recommendations/refine'),
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/gift_recommendations'),
}
